export default __webpack_public_path__ + "static/media/water-bottle.07d3e459.webp";